import React from "react";

const WhyNeo = () => {
  return (
    <div className="max-container lg:px-[96px] px-[20px] 2xl:mx-auto xxl:px-[156px] pt-[40px] lg:pt-[105px]">
      <div className="text-white lg:text-5xl text-[28px] font-semibold font-['Poppins'] text-center capitalize lg:leading-[62.40px] leading-9 lg:mb-12 mb-8">
        Why Choose NeoTrader
      </div>
      <div className="grid lg:grid-cols-3 lg:gap-x-8 lg:gap-y-8 gap-y-6 gap-x-0">
        <div className="lg:py-[30px] lg:px-[25px] py-8 px-4 w-full lg:h-[194px] boxBg rounded-[30px] border border-zinc-300 border-opacity-20">
          <div className="text-[#33d6ad] lg:text-2xl text-xl font-semibold font-['Aileron'] lg:leading-[31.20px] leading-relaxed tracking-wide">
            Money Earned
          </div>
          <div className="h-14 text-[#fff] lg:text-xl text-base font-normal font-['Aileron'] lg:leading-7 leading-snug tracking-[2%] lg:tracking-tight lg:mt-5 mt-3">
            Streamlined data, signals, indicators & expert alerts boost your
            trading success.
          </div>
        </div>
        <div className="lg:py-[30px] lg:px-[25px] py-8 px-4 w-full lg:h-[194px] boxBg rounded-[30px] border border-zinc-300 border-opacity-20">
          <div className="text-[#33d6ad] lg:text-2xl text-xl font-semibold font-['Aileron'] lg:leading-[31.20px] leading-relaxed tracking-wide">
            Effort Reduced
          </div>
          <div className="h-14 text-[#fff] lg:text-xl text-base font-normal font-['Aileron'] lg:leading-7 leading-snug tracking-[2%] lg:tracking-tight lg:mt-5 mt-3">
            NeoTrader’s API enables a seamless trade execution without giving
            any extra effort.
          </div>
        </div>
        <div className="lg:py-[30px] lg:px-[25px] py-8 px-4 w-full lg:h-[194px] boxBg rounded-[30px] border border-zinc-300 border-opacity-20">
          <div className="text-[#33d6ad] lg:text-2xl text-xl font-semibold font-['Aileron'] lg:leading-[31.20px] leading-relaxed tracking-[4%] lg:tracking-wide">
            Time Saved
          </div>
          <div className="h-14 text-[#fff] lg:text-xl text-base font-normal font-['Aileron'] lg:leading-7 leading-snug tracking-[2%] lg:tracking-tight lg:mt-5 mt-3">
            Readymade dashboard & heatmap provide a daily market view, thus
            saving time.
          </div>
        </div>
        {/*  <div className="lg:py-[42px] lg:px-[36px] py-8 px-4 w-full h-[194px] bg-gradient-to-b  from-fuchsia-950 to-gray-900 rounded-[30px] border border-zinc-300 border-opacity-20">
          <div className="text-teal-400 lg:text-2xl text-xl font-bold font-['Aileron'] lg:leading-[31.20px] leading-relaxed tracking-wide">
            4. Direct Execution
          </div>
          <div className="h-14 text-zinc-400 lg:text-xl text-base font-normal font-['Aileron'] lg:leading-7 leading-snug tracking-tight lg:mt-5 mt-3">
          NeoTrader's API integration with leading brokers like Zerodha, Dhan, 5 Paisa, Fyers & Alice Blue enables seamless trade execution without taking extra time.
          </div>
  </div>*/}
      </div>
    </div>
  );
};

export default WhyNeo;
